module.exports = __webpack_public_path__ + "static/media/4photoshoot.0f4e915a.jpg";